// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"4ca70be2","347":"d61c0c27","631":"0f49be30","725":"b86073c4","829":"24e38b92","882":"866446f4","929":"6c86f946","997":"6a54e867"}[chunkId] + ".chunk.js";
};